import { render, staticRenderFns } from "./RelationshipPreviousPersonName.vue?vue&type=template&id=5b8fdfe4"
import script from "./RelationshipPreviousPersonName.vue?vue&type=script&lang=js"
export * from "./RelationshipPreviousPersonName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports